import { Component, Inject } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import {
  MAT_DIALOG_DATA,
  MatDialogActions,
  MatDialogContent,
  MatDialogRef,
  MatDialogTitle,
} from '@angular/material/dialog';
import { MatIcon } from '@angular/material/icon';
import { MatIconButton } from '@angular/material/button';
import { Notification } from '@app-types/notification';
import { CdkCopyToClipboard } from '@angular/cdk/clipboard';
import { MatSnackBarConfig } from '@angular/material/snack-bar';
import { SnackbarService } from '@app-services/snackbar.service';

@Component({
  selector: 'app-notification-dialog',
  templateUrl: './notification-dialog.component.html',
  styleUrls: ['./notification-dialog.component.scss'],
  imports: [
    TranslateModule,
    MatDialogTitle,
    MatIcon,
    MatIconButton,
    MatDialogContent,
    MatDialogActions,
    CdkCopyToClipboard,
  ],
})
export class NotificationDialogComponent {
  constructor(
    public dialogRef: MatDialogRef<NotificationDialogComponent>,
    @Inject(MAT_DIALOG_DATA)
    public data: {
      notification: Notification;
    },
    private snackbarService: SnackbarService
  ) {}

  copy(): void {
    const config: MatSnackBarConfig = {
      verticalPosition: 'bottom',
      horizontalPosition: 'center',
      duration: 1000,
    };
    this.snackbarService.openSnackBar('copiedStatus', '', config);
  }
}
